import { Armature } from "..";
import { JointPositions } from "../../types";

import { Joint } from "../joint";
import { PointType } from "../metadata";

import { clipEdgeLength, Group } from "./group";

export class OrphanGroup extends Group {
  joints: Joint[] = [];

  constructor(base: Joint) {
    super();

    let current: Joint | undefined = base;
    while (current) {
      if (base != current && current.props.type != PointType.FLOATING) {
        console.error("orphan groups must be made of floating joints");
        break;
      }

      this.joints.push(current);
      if (current.childEdges.length > 1) {
        console.error("orphan groups can't have branches");
        break;
      }
      current = current.childEdges[0]?.end;
    }

    // label each joint so we can check for membership in solver
    for (const joint of this.joints) {
      joint.group = this;
    }
  }

  get name(): string {
    return `orphan: ${this.joints[0]?.name}`;
  }

  solveForward(_targets: JointPositions) {
    return true;
  }

  solveBackward(_targets: JointPositions) {
    for (const joint of this.joints) {
      if (joint.parentEdge?.hasConstraints()) {
        joint.parentEdge.applyConstraints(true);
      } else if (joint.parentEdge) {
        clipEdgeLength(joint.parentEdge, true);
      }
    }

    return true;
  }
}
